export default "__VITE_ASSET__CXWzmJee__"